/**
 * Closed lists of the domain (Technical Specifications, section 5.3).
 * Each list is exported as a readonly tuple, a union type and a zod enum, so that the same
 * definition serves the database, the API contract, the web forms and the mobile application.
 */
import { z } from 'zod';
export const WASTE_TYPES = [
    'DND',
    'DD',
    'INERTE',
    'DASRI',
    'MATIERES_REVENDUES',
    'RADIOACTIF',
    'DD_AMIANTE',
    'FLUIDES_FRIGORIGENES',
    'TERRES_EXCAVEES',
];
export const wasteTypeSchema = z.enum(WASTE_TYPES);
/** Types that are hazardous by nature (BR-01). */
export const HAZARDOUS_WASTE_TYPES = [
    'DD',
    'DASRI',
    'DD_AMIANTE',
    'RADIOACTIF',
    'FLUIDES_FRIGORIGENES',
];
export const CONSISTENCIES = [
    'SOLIDE',
    'LIQUIDE',
    'PATEUX_LIQUIDE',
    'PULVERULENT',
    'GAZEUX',
    'PATEUX_SOLIDE',
];
export const consistencySchema = z.enum(CONSISTENCIES);
export const PRESTATAIRE_TYPES = [
    'NEGOCIANT',
    'COURTIER',
    'TRANSPORTEUR_ROUTE',
    'TRANSPORTEUR_RAIL',
    'TRANSPORTEUR_MER',
    'TRANSPORTEUR_AIR',
    'TRANSPORTEUR_PIPE',
    'CENTRE_ENTREPOSAGE',
    'CENTRE_TRAITEMENT',
    'ENTREPRISE_TRAVAUX',
];
export const prestataireTypeSchema = z.enum(PRESTATAIRE_TYPES);
export const BSD_TYPES = [
    'BSD_DANGEREUX',
    'BSD_NON_DANGEREUX',
    'BSD_DASRI',
    'BON_ENLEVEMENT',
    'DOCUMENT_PERSONNALISE',
];
export const bsdTypeSchema = z.enum(BSD_TYPES);
export const EXPEDITION_STATUSES = [
    'DRAFT',
    'READY',
    'AWAITING_SHIPMENT',
    'SIGNED_BY_PRODUCER',
    'SHIPPED',
    'RECEIVED',
    'ACCEPTED',
    'PARTIALLY_REFUSED',
    'REFUSED',
    'TEMP_STORED',
    'FORWARDED',
    'TREATED',
    'CANCELLED',
];
export const expeditionStatusSchema = z.enum(EXPEDITION_STATUSES);
export const TRACEABILITY_STATUSES = [
    'NOT_TRACKED',
    'PENDING',
    'RETURNED_ON_TIME',
    'RETURNED_LATE',
    'OVERDUE',
    'CLOSED',
];
export const traceabilityStatusSchema = z.enum(TRACEABILITY_STATUSES);
export const QUANTITY_UNITS = ['T', 'KG', 'M3', 'L', 'UNIT'];
export const quantityUnitSchema = z.enum(QUANTITY_UNITS);
export const COST_KINDS = [
    'TRANSPORT',
    'TRAITEMENT',
    'TAXE',
    'ACHAT_CONDITIONNEMENT',
    'RECETTE',
    'AUTRE_OPERATION',
    'LOCATION_CONDITIONNEMENT',
    'FRAIS_ANNEXES',
];
export const costKindSchema = z.enum(COST_KINDS);
export const AUTHORIZATION_KINDS = [
    'COLLECTE_TRANSPORT',
    'INSTALLATION_TRAITEMENT',
    'INSTALLATION_STOCKAGE',
    'DECHARGE_CLASSE_3',
    'AUTRE',
];
export const authorizationKindSchema = z.enum(AUTHORIZATION_KINDS);
export const TRANSPORT_MODES = ['ROUTE', 'RAIL', 'MER', 'AIR', 'PIPE'];
export const transportModeSchema = z.enum(TRANSPORT_MODES);
export const CONDITIONNEMENT_CATEGORIES = [
    'AUTRE_COLIS',
    'BENNE',
    'RACKS',
    'CITERNE',
    'AUTRE_VRAC',
    'DOUBLE_SAC_GC_GRV',
    'FUT',
    'GRV',
    'PALETTE_FILMEE',
];
export const conditionnementCategorySchema = z.enum(CONDITIONNEMENT_CATEGORIES);
/** Roles of the rights matrix (Functional Specifications, section 4.3). */
export const ROLES = [
    'SITE_READER',
    'SITE_OPERATOR',
    'SITE_MANAGER',
    'SITE_ADMIN',
    'FINANCE',
    'TENANT_ADMIN',
    'GROUP_ANALYST',
    'VENDOR_SUPPORT',
    'PLATFORM_OPERATOR',
];
export const roleSchema = z.enum(ROLES);
export const ROLE_SCOPE_KINDS = ['TENANT', 'COMPANY', 'SITE'];
export const roleScopeKindSchema = z.enum(ROLE_SCOPE_KINDS);
export const LOCALES = ['fr', 'ar', 'en'];
export const localeSchema = z.enum(LOCALES);
//# sourceMappingURL=enums.js.map